import { tsl_svarvidtelefon } from './Generated/tsl_svarvidtelefon';

export const ContactAttemptAnswerText: {
  [key in tsl_svarvidtelefon]: string;
} = {
  [tsl_svarvidtelefon.Fickkontakt]: 'Fick kontakt',
  [tsl_svarvidtelefon.Ingetsvar]: 'Inget svar',
};
